import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../SharedModule/redux/reducers/uiShared.reducer";
import {
  CLIENTS_ALL_ROLES,
  CLIENTS_CONTACTS_REPORTS_ACCESS,
  ROUTE_CLIENTS_REPORTS,
  CLIENTS_ADMIN_ACCESS,
  ROUTE_CLIENTS,
  CLIENTS_VIEWER_ACCESS,
  ROUTE_CLIENTS_ADVOCACY_SUMMARY_REPORT,
  ROUTE_CLIENTS_ADVOCACY_DETAIL_REPORT,
  ROUTE_CLIENTS_RELATIONSHIP_UPDATES_REPORT,
  ROUTE_CLIENTS_RELATIONSHIP_REVIEW_REPORT,
  ROUTE_CLIENTS_HUBSPOT_INTEGRATION_LOG_REPORT,
  CLIENTS_CONTACTS_ADMIN_ACCESS,
  ROUTE_CLIENTS_CHANGEGEAR_INTEGRATION_LOG_REPORT,
} from "../../SharedModule/utils/constants";
import DynamicBiIcon from "./../../SharedModule/components/DynamicBiIcon";
import Footer from "../../SharedModule/components/Footer";
import { verifyModuleAccess } from "../../SharedModule/utils/accessUtils";
import { Spinner } from "../../SharedModule/components/Spinner";
import { ForbiddenPage } from "../../SharedModule/pages/ForbiddenPage";
import { Link } from "react-router";
import { BiChevronRight } from "react-icons/bi";
import { selectUserRoles } from "../../SharedModule/redux/reducers/auth.reducer";
import { ExternalLink } from "../../SharedModule/components/ExternalLink";
import { ClientsService } from "../services/clients";
import { addToast } from "../../SharedModule/redux/reducers/ui.reducer";
import {
  exportToExcel,
  transformDataActiveItxClients,
} from "../../SharedModule/utils/exportToExcel";
import { getTodayFormatted } from "../../SharedModule/utils/formatters";

export const ClientReportsPage = () => {
  const dispatch = useDispatch();

  const { userRolesList, rolesLoaded } = useSelector(selectUserRoles);

  const linkToContactsReceived: any =
    process.env.REACT_APP_ASUITE_CONTACTS_RECEIVED_LINK;
  const linToClientRevenueComparision: any =
    process.env.REACT_APP_ASUITE_CLI_REVENUE_COMP_LINK;

  useEffect(() => {
    document.title = "The Hub - Client Reports Page";

    dispatch(setActiveTab(ROUTE_CLIENTS_REPORTS));
  }, []);

  const [isLoadingReport, setIsLoadingReport] = useState(false);

  const downloadReport = async (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();
    setIsLoadingReport(true);
    let reportInfo = await ClientsService.getSoc2ActiveClientsReport()
      .then((response) => {
        return response;
      })
      .catch(() => {
        dispatch(
          addToast({
            mode: "error",
            message: "Something wrong happened getting SOC2 Compliance Report.",
          })
        );
      });

    let fileName = "Active ITX Clients " + getTodayFormatted();
    exportToExcel(
      transformDataActiveItxClients(reportInfo),
      fileName,
      "activeITXclients"
    );
    setIsLoadingReport(false);
  };

  return (
    <>
      {!rolesLoaded && (
        <Spinner
          style={{
            marginLeft: "50%",
            marginTop: "5%",
          }}
        />
      )}
      {rolesLoaded &&
        !verifyModuleAccess(true, CLIENTS_ALL_ROLES, userRolesList) && (
          <ForbiddenPage />
        )}
      {rolesLoaded &&
        verifyModuleAccess(true, CLIENTS_ALL_ROLES, userRolesList) && (
          <div className="content">
            <h2 className="mb-5">Client Reports</h2>

            {isLoadingReport && (
              <Spinner
                style={{
                  marginLeft: "50%",
                  marginTop: "5%",
                }}
              />
            )}

            {!isLoadingReport && (
              <>
                {verifyModuleAccess(true, CLIENTS_ALL_ROLES, userRolesList) && (
                  <div className="d-flex flex-column">
                    <h4 className="mb-0">Advocacy Reports</h4>
                    <div className="d-flex flex-row flex-wrap">
                      <Link
                        className="card card-width-reports text-decoration-none entry-hour-box-background px-4 pt-3 pb-3 my-3 me-5"
                        to={ROUTE_CLIENTS_ADVOCACY_SUMMARY_REPORT}
                      >
                        <div className="d-flex flex-row">
                          <div className="left-column-reports">
                            <div className="d-flex flex-row">
                              <DynamicBiIcon
                                icon="BiBarChartAlt2"
                                className="icon-time-reports ms-1 me-3"
                              />
                              <div className="card-title-time-reports">
                                Advocacy Summary
                              </div>
                            </div>
                            <div className="d-flex flex-row mt-3 ms-1">
                              Contacts in each Relationship Level and
                              Stakeholder Confidence, by Client
                            </div>
                          </div>
                          <div className="right-column-reports">
                            <BiChevronRight className="arrow-icon-nohover" />
                          </div>
                        </div>
                      </Link>

                      <Link
                        className="card card-width-reports text-decoration-none entry-hour-box-background px-4 pt-3 pb-3 my-3 me-5"
                        to={ROUTE_CLIENTS_ADVOCACY_DETAIL_REPORT}
                      >
                        <div className="d-flex flex-row">
                          <div className="left-column-reports">
                            <div className="d-flex flex-row">
                              <DynamicBiIcon
                                icon="BiBarChartAlt2"
                                className="icon-time-reports ms-1 me-3"
                              />
                              <div className="card-title-time-reports">
                                Advocacy Detail
                              </div>
                            </div>
                            <div className="d-flex flex-row mt-3 ms-1">
                              Relationship Level and Stakeholder Confidence by
                              Contact
                            </div>
                          </div>
                          <div className="right-column-reports">
                            <BiChevronRight className="arrow-icon-nohover" />
                          </div>
                        </div>
                      </Link>

                      <Link
                        className="card card-width-reports text-decoration-none entry-hour-box-background px-4 pt-3 pb-3 my-3 me-5"
                        to={ROUTE_CLIENTS_RELATIONSHIP_UPDATES_REPORT}
                      >
                        <div className="d-flex flex-row">
                          <div className="left-column-reports">
                            <div className="d-flex flex-row">
                              <DynamicBiIcon
                                icon="BiBarChartAlt2"
                                className="icon-time-reports ms-1 me-3"
                              />
                              <div className="card-title-time-reports">
                                Relationship Updates
                              </div>
                            </div>
                            <div className="d-flex flex-row mt-3 ms-1">
                              Changes in Relationship Level in the last 30 days
                            </div>
                          </div>
                          <div className="right-column-reports">
                            <BiChevronRight className="arrow-icon-nohover" />
                          </div>
                        </div>
                      </Link>

                      <Link
                        className="card card-width-reports text-decoration-none entry-hour-box-background px-4 pt-3 pb-3 my-3"
                        to={ROUTE_CLIENTS_RELATIONSHIP_REVIEW_REPORT}
                      >
                        <div className="d-flex flex-row">
                          <div className="left-column-reports">
                            <div className="d-flex flex-row">
                              <DynamicBiIcon
                                icon="BiBarChartAlt2"
                                className="icon-time-reports ms-1 me-3"
                              />
                              <div className="card-title-time-reports">
                                Relationship Review
                              </div>
                            </div>
                            <div className="d-flex flex-row mt-3 ms-1">
                              Summary to be used during All Staff
                            </div>
                          </div>
                          <div className="right-column-reports">
                            <BiChevronRight className="arrow-icon-nohover" />
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                )}

                {verifyModuleAccess(
                  true,
                  CLIENTS_CONTACTS_REPORTS_ACCESS,
                  userRolesList
                ) && (
                  <div className="d-flex flex-column mt-4">
                    <h4 className="mb-0">Audit Reports</h4>
                    <div className="d-flex flex-row flex-wrap">
                      {verifyModuleAccess(
                        true,
                        CLIENTS_ADMIN_ACCESS,
                        userRolesList
                      ) && (
                        <Link
                          className="card card-width-reports text-decoration-none entry-hour-box-background px-4 pt-3 pb-3 my-3 me-5"
                          to={ROUTE_CLIENTS_HUBSPOT_INTEGRATION_LOG_REPORT}
                        >
                          <div className="d-flex flex-row">
                            <div className="left-column-reports">
                              <div className="d-flex flex-row">
                                <DynamicBiIcon
                                  icon="BiBarChartAlt2"
                                  className="icon-time-reports ms-1 me-3"
                                />
                                <div className="card-title-time-reports">
                                  HubSpot Integration Log
                                </div>
                              </div>
                              <div className="d-flex flex-row mt-3 ms-1">
                                Import of Client and Contact data from HubSpot
                              </div>
                            </div>
                            <div className="right-column-reports">
                              <BiChevronRight className="arrow-icon-nohover" />
                            </div>
                          </div>
                        </Link>
                      )}

                      {/* ChangeGear Integration Log report is not ready yet:
                      see the TODO on its .trdp report name pending
                      ASUITE11-3857. Re-enable this card (and register its
                      route in App.tsx) once that ticket lands.
                      {verifyModuleAccess(
                        true,
                        CLIENTS_CONTACTS_ADMIN_ACCESS,
                        userRolesList
                      ) && (
                        <Link
                          className="card card-width-reports text-decoration-none entry-hour-box-background px-4 pt-3 pb-3 my-3 me-5"
                          to={ROUTE_CLIENTS_CHANGEGEAR_INTEGRATION_LOG_REPORT}
                        >
                          <div className="d-flex flex-row">
                            <div className="left-column-reports">
                              <div className="d-flex flex-row">
                                <DynamicBiIcon
                                  icon="BiBarChartAlt2"
                                  className="icon-time-reports ms-1 me-3"
                                />
                                <div className="card-title-time-reports">
                                  ChangeGear Integration Log
                                </div>
                              </div>
                              <div className="d-flex flex-row mt-3 ms-1">
                                Daily export of Client and Contact data to
                                ChangeGear
                              </div>
                            </div>
                            <div className="right-column-reports">
                              <BiChevronRight className="arrow-icon-nohover" />
                            </div>
                          </div>
                        </Link>
                      )} */}

                      {verifyModuleAccess(
                        true,
                        CLIENTS_CONTACTS_REPORTS_ACCESS,
                        userRolesList
                      ) && (
                        <Link
                          className="card card-width-reports text-decoration-none entry-hour-box-background px-4 pt-3 pb-3 my-3 me-5"
                          to={"#"}
                          onClick={(e) => downloadReport(e)}
                        >
                          <div className="d-flex flex-row">
                            <div className="left-column-reports">
                              <div className="d-flex flex-row">
                                <DynamicBiIcon
                                  icon="BiBarChartAlt2"
                                  className="icon-time-reports ms-1 me-3"
                                />
                                <div className="card-title-time-reports">
                                  Active ITX Clients
                                </div>
                              </div>
                              <div className="d-flex flex-row mt-3 ms-1">
                                Clients with work in the last 18 months, for
                                SOC2 purposes
                              </div>
                            </div>
                            <div className="right-column-reports">
                              <BiChevronRight className="arrow-icon-nohover" />
                            </div>
                          </div>
                        </Link>
                      )}
                    </div>
                  </div>
                )}

                {verifyModuleAccess(
                  true,
                  CLIENTS_VIEWER_ACCESS,
                  userRolesList
                ) && (
                  <div className="d-flex flex-column mt-4">
                    <h4 className="mb-0">Historical Reports</h4>
                    <div className="d-flex flex-row flex-wrap">
                      <ExternalLink
                        className="card card-width-reports text-decoration-none entry-hour-box-background pointer px-4 pt-3 pb-3 my-3  me-5"
                        to={linkToContactsReceived}
                      >
                        <div className="d-flex flex-row">
                          <div className="left-column-reports">
                            <div className="d-flex flex-row">
                              <DynamicBiIcon
                                icon="BiBarChartAlt2"
                                className="icon-time-reports ms-1 me-3"
                              />
                              <div className="card-title-time-reports">
                                Historical Contracts Received
                              </div>
                            </div>
                            <div className="d-flex flex-row mt-3 ms-1">
                              Closed Opportunities until 2022
                            </div>
                          </div>
                          <div className="right-column-reports">
                            <BiChevronRight className="arrow-icon-nohover" />
                          </div>
                        </div>
                      </ExternalLink>

                      <ExternalLink
                        className="card card-width-reports text-decoration-none entry-hour-box-background pointer px-4 pt-3 pb-3 my-3"
                        to={linToClientRevenueComparision}
                      >
                        <div className="d-flex flex-row">
                          <div className="left-column-reports">
                            <div className="d-flex flex-row">
                              <DynamicBiIcon
                                icon="BiBarChartAlt2"
                                className="icon-time-reports ms-1 me-3"
                              />
                              <div className="card-title-time-reports">
                                Client Revenue Comparison
                              </div>
                            </div>
                            <div className="d-flex flex-row mt-3 ms-1">
                              Yearly sum of Invoices by Client
                            </div>
                          </div>
                          <div className="right-column-reports">
                            <BiChevronRight className="arrow-icon-nohover" />
                          </div>
                        </div>
                      </ExternalLink>
                    </div>
                  </div>
                )}
              </>
            )}

            <Footer />
          </div>
        )}
    </>
  );
};
